<div [ngClass]="displayTheme">
    <label [ngClass]="{'checked': isChecked}">
        <img [src]="(isChecked) ? iconCheck : icon">&nbsp;
        <p class="mt-3 mb-3" *ngIf="displayTheme == 'lg-radio-button-with-icon'"></p>
        <ng-content></ng-content>
        <p class="mb-3" *ngIf="displayTheme == 'lg-radio-button-with-icon'"></p>
        <input #radioField type="radio" [name]="name" [value]="value" [ngClass]="{'icon': icon}"
            (change)='emiteValue(value)' [checked]='isChecked'>
    </label>
</div>